module.exports = __webpack_public_path__ + "media/assets/images/twitter_icon-877261bfa2ff69dded07f9652b0150c4.png";